var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navigation'),_c('keep-alive',{attrs:{"include":"Index,About,Contact,Anli,Dssj,Weixin,Wzjs,Wzyx,Fangan,Zhishi,Zhishi-app,Zhishi-dianshang,Zhishi-ruanjian,Zhishi-tuiguang,Zhishi-wangzhan,Zhishi-xiaochengxu"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }